import { render, staticRenderFns } from "./pendingShop.vue?vue&type=template&id=022fec19&scoped=true"
import script from "./pendingShop.vue?vue&type=script&lang=js"
export * from "./pendingShop.vue?vue&type=script&lang=js"
import style0 from "./pendingShop.vue?vue&type=style&index=0&id=022fec19&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fec19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022fec19')) {
      api.createRecord('022fec19', component.options)
    } else {
      api.reload('022fec19', component.options)
    }
    module.hot.accept("./pendingShop.vue?vue&type=template&id=022fec19&scoped=true", function () {
      api.rerender('022fec19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/pendingShop/pendingShop.vue"
export default component.exports